import { render, staticRenderFns } from "./productReview.vue?vue&type=template&id=ebf5b216"
import script from "./productReview.vue?vue&type=script&lang=js"
export * from "./productReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports